export const initReassurance = () => {
    const toggleItems = document.querySelectorAll(
        ".block-reassurance-item--hasToggle"
    );

    toggleItems.forEach((item) => {
        const heading = item.querySelector(".block-reassurance-item__heading");
        const description = item.querySelector(
            ".block-reassurance-item__description"
        );

        if (!description) return;

        if (!item.classList.contains("toggleActive")) {
            description.style.maxHeight = "0px";
        } else {
            description.style.maxHeight = description.scrollHeight + "px";
        }
        description.style.overflow = "hidden";
        description.style.transition = "max-height 0.4s ease";

        heading.addEventListener("click", () => {
            const isActive = item.classList.toggle("toggleActive");
            description.style.maxHeight = isActive
                ? description.scrollHeight + "px"
                : "0px";
        });
    });

    // ----------

    const addBusinessDaysToDateNow = (days) => {
        let result = new Date();
        while (days > 0) {
            result.setDate(result.getDate() + 1);
            const day = result.getDay();
            if (day !== 0 && day !== 6) days--;
        }
        return result;
    };

    const showColorInfo = () => {
        document.querySelectorAll(".variations .color-production-time").forEach((el) => {
            el.classList.remove("hidden");
        });
    }

    const hideColorInfo = () => {
        document.querySelectorAll(".variations .color-production-time").forEach((el) => {
            el.classList.add("hidden");
        });
    }

    const showNatual = () => {
        document.querySelectorAll(".block-reassurance .block-reassurance-item--shipping .for_natural").forEach((el) => {
            el.classList.remove("hidden");
        });
        document.querySelectorAll(".block-reassurance .block-reassurance-item--shipping .for_painted").forEach((el) => {
            el.classList.add("hidden");
        });
    }

    const showPainted = () => {
        document.querySelectorAll(".block-reassurance .block-reassurance-item--shipping .for_natural").forEach((el) => {
            el.classList.add("hidden");
        });
        document.querySelectorAll(".block-reassurance .block-reassurance-item--shipping .for_painted").forEach((el) => {
            el.classList.remove("hidden");
        });
    }

    const getProductionTimeForVariation = (variation, isNatural) => {
        const defaultPainted = window.productionTimeOfPaintedWood;
        const defaultNatural = window.productionTimeOfNaturalWood;
        const byGroup = window.productionTimeByGroup;
        const productVariableId = variation.product_variable_id;

        if (byGroup && productVariableId) {
            for (const el of byGroup) {
                if (el.products_in_group.includes(productVariableId)) {
                    return isNatural
                        ? {
                            from: el.production_time_of_natural_wood.from,
                            to: el.production_time_of_natural_wood.to,
                        }
                        : {
                            from: el.production_time_of_painted_wood.from,
                            to: el.production_time_of_painted_wood.to,
                        };
                }
            }
        }

        if (isNatural) {
            if (!defaultNatural) return false;

            return {
                from: defaultNatural.from,
                to: defaultNatural.to,
            }
        } else {
            if (!defaultPainted) return false;

            return {
                from: defaultPainted.from,
                to: defaultPainted.to,
            }
        }
    }

    const calculateProductionTime = (variation) => {
        if (!variation || !variation.variation_id || !variation.attributes) return;

        //TODO: tutaj trzeba kiedyś poprawić
        const isNatural = variation.attributes.attribute_pa_couleur === 'naturel' || variation.attributes.attribute_pa_couleur === 'naturale';

        const productionTime = getProductionTimeForVariation(variation, isNatural);

        if (false === productionTime) return;

        let dateFrom = addBusinessDaysToDateNow(productionTime.from);
        let dateTo = addBusinessDaysToDateNow(productionTime.to);

        if (isNatural) {
            showNatual();
        } else {
            showPainted();
        }

        const options = { day: '2-digit', month: '2-digit' };
        dateFrom = dateFrom.toLocaleDateString(undefined, options);
        dateTo = dateTo.toLocaleDateString(undefined, options);

        document.querySelectorAll(".variations .color-production-time .dateFrom, .block-reassurance .block-reassurance-item--shipping .dateFrom").forEach((el) => {
            el.textContent = dateFrom;
        });

        document.querySelectorAll(".variations .color-production-time .dateTo, .block-reassurance .block-reassurance-item--shipping .dateTo").forEach((el) => {
            el.textContent = dateTo;
        });
    };

    // --- Harmonogram (dni tygodnia / daty / godziny) ------------------------
    // Czas pochodzi z WordPressa (endpoint admin-ajax), bo strona jest
    // cache'owana i ten sam kod działa na różnych rynkach (różne strefy).

    const getScheduleItems = () =>
        document.querySelectorAll(
            ".block-reassurance .block-reassurance-item[data-schedule]"
        );

    const evaluateSchedule = (schedule, now) => {
        // now: { date: 'YYYY-MM-DD', dow: 1..7 (pon..niedz), time: 'HH:MM:SS' }
        if (!schedule) return true;

        const days = Array.isArray(schedule.days) ? schedule.days : [];
        if (days.length && !days.includes(now.dow)) return false;

        const only = Array.isArray(schedule.only) ? schedule.only : [];
        if (only.length && !only.includes(now.date)) return false;

        const exclude = Array.isArray(schedule.exclude) ? schedule.exclude : [];
        if (exclude.length && exclude.includes(now.date)) return false;

        const from = schedule.from || "";
        const to = schedule.to || "";
        if (from && to) {
            const cur = now.time;
            if (from <= to) {
                if (!(cur >= from && cur < to)) return false;
            } else {
                // przedział nocny, np. 22:00:00 - 06:00:00
                if (!(cur >= from || cur < to)) return false;
            }
        }

        return true;
    };

    const applyScheduleGate = (now) => {
        getScheduleItems().forEach((el) => {
            let schedule = null;
            try {
                schedule = JSON.parse(el.dataset.schedule);
            } catch (e) {
                schedule = null;
            }

            if (evaluateSchedule(schedule, now)) {
                el.dataset.scheduleHidden = "0";
            } else {
                el.dataset.scheduleHidden = "1";
                el.classList.add("hidden");
            }

            el.classList.remove("is-schedule-pending");
        });
    };

    const initScheduleVisibility = () => {
        const items = getScheduleItems();
        if (!items.length) return;

        const ajaxUrl =
            (window.sebaNavbarAjax && window.sebaNavbarAjax.ajaxUrl) ||
            "/wp-admin/admin-ajax.php";

        const revealPending = () =>
            items.forEach((el) => el.classList.remove("is-schedule-pending"));

        fetch(`${ajaxUrl}?action=seba_reassurance_now`, {
            method: "GET",
            cache: "no-store",
            credentials: "same-origin",
        })
            .then((res) => res.json())
            .then((res) => {
                if (!res || !res.success || !res.data) {
                    // brak czasu serwera — nie blokujemy, pokaż elementy
                    revealPending();
                    return;
                }
                applyScheduleGate({
                    date: res.data.date,
                    dow: parseInt(res.data.dow, 10),
                    time: res.data.time,
                });
            })
            .catch(revealPending);
    };

    // Pokaż element tylko jeśli harmonogram na to pozwala (brama czasowa).
    const showIfScheduleAllows = (el) => {
        if (el.dataset.scheduleHidden === "1") return;
        el.classList.remove("hidden");
    };

    const setVisibilityItems = (variation) => {
        let visibility = 0; // pokazuj zawsze

        if(variation.manage_stock) {
          if (variation.stock_quantity > 0) {
            visibility = 1; //pokazuj gdy magazyn włączony i stan jest większy niż 0
          } else {
            visibility = 2; // pokazuj gdy magazyn włączony i stan mniejszy lub równy 0
          }
        } else {
          visibility = 3;
        }

        if(visibility === 1 ) {
          hideColorInfo();
        } else {
          showColorInfo();
        }

        document.querySelectorAll(".block-reassurance .block-reassurance-item").forEach((el) => {
            let visibilityItem = el.dataset.visibility || 0;
            visibilityItem = parseInt(visibilityItem);
            if(visibilityItem === 0) {
                showIfScheduleAllows(el);
                return;
            }

            if (visibility === visibilityItem) {
                showIfScheduleAllows(el);
            } else {
                el.classList.add("hidden");
            }
        });
    }

    const setStockQuantity = (variation) => {
        document.querySelectorAll(".block-reassurance .block-reassurance-item .stockQuantity").forEach((el) => {
            el.textContent = variation.stock_quantity;
        });
    }

    initScheduleVisibility();

    jQuery(document).ready(function ($) {
        $('form.variations_form').on('found_variation', function (event, variation) {
            calculateProductionTime(variation);
            setVisibilityItems(variation);
            setStockQuantity(variation);
        });
    });
};
